import {JSGallery2} from "./EventgalleryJSGallery2";


/* start the eventgallery*/
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.ajaxpaging').forEach((galleryElement) => {

        new JSGallery2(
            galleryElement,
            galleryElement.querySelectorAll('.ajax-thumbnail-container'),
            galleryElement.querySelector('#bigimageContainer'),
            galleryElement.querySelector('#pageContainer'),
            {
                'prevHandle': galleryElement.querySelector('#prev'),
                'nextHandle': galleryElement.querySelector('#next'),
                'countHandle': galleryElement.querySelector('#count'),
                'titleTarget': '#bigImageDescription',
                'showSocialMediaButton': galleryElement.getAttribute('data-showSocialMediaButton')=='true',
                'showCartButton': galleryElement.getAttribute('data-showCartButton')=='true',
                'showCartConnector': galleryElement.getAttribute('data-showCartConnector')=='true',
                'cartConnectorLinkRel': galleryElement.getAttribute('data-cartConnectorLinkRel'),
                'maxHeight': parseInt(galleryElement.getAttribute('data-maxHeight'), 10) || 280
            });

    });
});
